module.exports = __webpack_public_path__ + "static/headroom-60cfc08a4ed7a66fcc1c7e184c5178d4.mp4";